import React, { useState, useRef, useEffect } from 'react';

import './patient.emergencyContact.scss';
import Input from '../../forms/inputs/Input';
import Select from '../../forms/inputs/Select';
import { buildStateObjectReducer } from '../../utils/stateReducer';
import Button from '../../forms/buttons/Button';
import CreateUserPhoneList from '../../users/assignment/Users.create.phoneList';
import ButtonIcon from '../../forms/buttons/Button.icon';
import InputTag from "../../forms/inputs/Input.tag";
import {useTranslation} from "react-i18next";
import AuditTrail from "../../services/interactions/audit.trail";

function EmergencyContactEntry({ event, defaultCountry, parentError, emergencyContact, index, removeContact, onComplete, disableMain }) {
    const {t} = useTranslation(['users'])
    const [contact, _setContact] = useState(emergencyContact);
    const [wasImported, setWasImported] = useState(false);
    const init = useRef(true);
    const setContact = (contact) => {
        if (!wasImported) {
            setWasImported(true);
        }
        _setContact(contact);
    }
    const [getContactPros, setContactProps] = buildStateObjectReducer(contact, setContact);
    useEffect(() => {
        if (!wasImported && emergencyContact.firstname) {
            console.log('contact: ', contact);
            console.log('emergencyContact: ', emergencyContact);
            _setContact(emergencyContact);
            setWasImported(true)
        }
    }, [emergencyContact, contact, wasImported])

    useEffect(() => {
        const allValid = [getContactPros('lastname'), getContactPros('firstname'), getContactPros('relationship'), getContactPros('phones')].reduce((p, c) => {
            return p && !!c;
        }, true)
        if (!init.current) {
            onComplete(contact);
        }
        init.current = false;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [contact])

    const goToMain = () => {
        AuditTrail.sendLog(event, {tag: 'tab', event: 'onChange', action: 'change tab', value: 'EmergencyOnly'});
        setContactProps('contactType')('EmergencyOnly');
        if (getContactPros('relationship') === 'orderingProvider') {
            setContactProps('relationship')('other')
        }
    }

    const goToSecond = () => {
        AuditTrail.sendLog(event, {tag: 'tab', event: 'onChange', action: 'change tab', value: 'Secondary'});
        setContactProps('contactType')('Secondary');
    }
    const goToEm = () => {
        setContactProps('contactType')('EmergencyOnly');
    }

    const conditionalMissing = (condition, ownValue) => {
        if (condition && !ownValue) {
            return true;
        }
        return false;
    }

    const hasError = (type, v) => {
        if (type === 'email') {
            if (!(!!v)) {
                return false;
            }
            const re = /^\S+@\S+\.\S+$/;
            return !re.test(String(v).toLowerCase());
        }
        return v && v.length === 0;
    }

    const relationShipOptions = [
        { value: 'child', label: t('relation-ship-type.child') },
        { value: 'friend', label: t('relation-ship-type.friend') },
        { value: 'neighbour', label: t('relation-ship-type.neighbour') },
        { value: 'parent', label: t('relation-ship-type.parent') },
        { value: 'partner', label: t('relation-ship-type.partner') },
        { value: 'sibling', label: t('relation-ship-type.sibling') },
        { value: 'spouse', label: t('relation-ship-type.spouse') },
        { value: 'other', label: t('other') }
    ];
    return (
        <div className="_emergencyContact">
            <div className="_contactTypeSelect">
                <div className="_tabulator">
                    <p className="label">Type</p>
                    <Button className={`first ${getContactPros('contactType') === 'EmergencyOnly' ? 'active' : ''}`} handleClick={goToMain} disabled={disableMain}>
                        <div className="shadow">
                            <span>{t('emergency-contact')}</span>
                        </div>
                    </Button>
                    <Button className={`${getContactPros('contactType') === 'Secondary' ? 'active' : ''}`} handleClick={goToSecond}>
                        <div className="shadow">
                            <span>{t('secondary')}</span>
                        </div>
                    </Button>
                    {
                        index > 0 ?
                            <div className="_contactDelete">
                                <div>
                                    <span className="material-icons _deleteButton">delete</span>
                                    <span onClick={removeContact}>{t('delete-contact')}</span>
                                </div>
                            </div>
                            : ''
                    }
                </div>
                <div className="_slider">

                    <div className={`_contactRow _sectionContact`}>
                        <div className="_contactRow two">
                            <Input required={true} error={hasError('text', getContactPros('lastname'))} value={getContactPros('lastname')} onChange={setContactProps('lastname')} placeholder={t('last-name')} label={t('last-name')} event={event} />
                            <Input required={true} error={hasError('text', getContactPros('firstname'))} value={getContactPros('firstname')} onChange={setContactProps('firstname')} placeholder={t('first-name')} label={t('first-name')} event={event} />
                        </div>
                        <div className="_contactRow two left">
                            <Input required={false} error={hasError('email', getContactPros('email'))} value={getContactPros('email')} onChange={setContactProps('email')} placeholder={t('email')} label={t('email')} event={event} />
                            <Select required={true} error={hasError('text', getContactPros('relationship'))} value={getContactPros('relationship')} onChange={setContactProps('relationship')} label={t('relationship-type')} placeholder={t('select')} options={relationShipOptions} event={event} />
                        </div>
                        <CreateUserPhoneList event={event} prefix="emergency" defaultCountry={defaultCountry} required={getContactPros('relationship') === 'orderingProvider' || getContactPros('contactType') === 'EmergencyOnly'} error={conditionalMissing(getContactPros('relationship') === 'orderingProvider', getContactPros('phones'))} phones={getContactPros('phones')} onChange={setContactProps('phones')} />
                        <InputTag tagsList={getContactPros('tags')} onAddTag={setContactProps('tags')} labelButton={t('add-tags')} />
                    </div>
                </div>
            </div>
        </div>
    )
}



export default function PatientEmergencyContacts({ event, defaultCountry, error, emergencyContacts, onChange }) {
    // const [wasImported, setWasImported] = useState(false);
    const {t} = useTranslation(['users']);
    const _contacts = emergencyContacts && emergencyContacts.length ? emergencyContacts : [{ contactType: 'EmergencyOnly' }];
    const addContacts = () => {
        AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button add new emergency contact'});
        _contacts.push({ contactType: 'Secondary' });
        onChange(JSON.parse(JSON.stringify(_contacts)));
    }

    const removeContact = (i) => {
        return () => {
            AuditTrail.sendLog(event, {tag: 'button', event: 'onClick', action: 'button del emergency contact', value: _contacts[i]});
            _contacts.splice(i, 1);
            onChange(JSON.parse(JSON.stringify(_contacts)));
        }
    }

    const onComplete = (index) => {
        return (modified) => {
            _contacts[index] = modified;
            onChange(JSON.parse(JSON.stringify(_contacts)));
        }
    }
    return (
        <div className="contactsList">
            {
                _contacts.map((contact, i) => {
                    const mainWasUsed = _contacts.filter((c, ind) => ind !== i).some(c => c.contactType === 'EmergencyOnly')
                    return (
                        <div key={i}>
                            <EmergencyContactEntry event={event} defaultCountry={defaultCountry} parentError={error} emergencyContact={contact} key={i} index={i} removeContact={removeContact(i)} disableMain={mainWasUsed} onComplete={onComplete(i)} />
                        </div>
                    )
                })
            }
            <div className="_actionButton">
                <ButtonIcon size={44} handleClick={addContacts}>
                    <span className="material-icons">
                        add
                    </span>
                </ButtonIcon>
                <p>
                    {t('add-contact')}
                </p>
            </div>
        </div>
    )
}
